<form [formGroup]="formGroup" (ngSubmit)="ok(formGroup)" novalidate>
  <h2 mat-dialog-title>{{ data.titel }}</h2>
  <mat-dialog-content>
    @if (message.message) {
      <div
        class="alert alert-success"
        [ngClass]="{ 'alert-success': message.success, 'alert-danger': !message.success }"
        >
        {{ message.message }}
      </div>
    }
    @if (formGroup.get('status').value !== 1) {
      <mat-radio-group aria-label="Vælg årsag til afvisning" formControlName="status">
        <mat-radio-button [value]="2">Fakturaen skal ikke betales</mat-radio-button>
        <mat-radio-button [value]="3">Jeg skal ikke godkende denne faktura</mat-radio-button>
      </mat-radio-group>
    }
    <mat-form-field>
      <!--
      Følgende felt er indsat pga. Google Chrome meddelelse:
      Password forms should have (optionally hidden) username fields for accessibility
      -->
      <input type="text" autocomplete="username" style="display: none" />
      <input
        type="password"
        id="Kodeord"
        name="kodeord"
        matInput
        placeholder="Kodeord"
        formControlName="kodeord"
        [required]="formGroup.get('status').value !== 3"
        autocomplete="current-password"
        />
        @if (
          formGroup.controls['kodeord'] && formGroup.controls['kodeord'].errors && formGroup.controls['kodeord'].errors.required
          ) {
          <mat-error
            >Indtast dit personlige kodeord</mat-error
            >
        }
        @if (
          formGroup.controls['kodeord'] &&
          formGroup.controls['kodeord'].errors &&
          formGroup.controls['kodeord'].errors.ugyldigKode
          ) {
          <mat-error
            >Kodeordet er ikke gyldigt</mat-error
            >
          }
        </mat-form-field>
        <mat-form-field>
          <textarea
            matInput
            id="Bemaerkning"
            name="bemaerkning"
            formControlName="bemaerkning"
            rows="4"
            style="width: 100%"
            placeholder="Bem&aelig;rkning"
          ></textarea>
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Annuller</button>
        <button type="submit" mat-flat-button color="primary">Ok</button>
      </mat-dialog-actions>
    </form>
    @if (working) {
      <div class="modal-overlay">
        <mat-spinner class="mat-spinner"></mat-spinner>
      </div>
    }
